module.exports = __webpack_public_path__ + "img/comment-arrow-up.6131da1a.svg";